import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Customer, Nullable } from 'corgi-types';
import { margin, marginBottom, marginTop } from 'styled-system';

import { ButtonLink } from 'common/components/Button';
import { Link } from 'common/components/Link';
import { HOTJAR_SUPPRESS_ATTRS } from 'common/constants/hotjar';
import { useLocalization } from 'common/providers/LocaleProvider';
import { Element } from 'common/types/tracking';
import { trackMyAccountTooltipClick } from '../../tracking';

interface UpperBlockProps {
  customer?: Nullable<Customer>;
}

const UpperBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorisedUpperBlock = ({ fullName }) => {
  const { t } = useLocalization();

  return (
    <span {...HOTJAR_SUPPRESS_ATTRS}>
      {t('h24_hello')} {fullName}
    </span>
  );
};

const NewCustomerContainer = styled.p<any>`
  ${margin}
  ${marginTop}
  ${marginBottom}
`;

const newCustomerContainerStyles: ComponentProps<typeof NewCustomerContainer> = {
  m: 'sp_0',
  mt: ['sp_16', null, 'sp_8'],
  mb: ['sp_8', null, 'sp_0'],
};

const UnauthorisedUpperBlock = ({}) => {
  const { t, prefix } = useLocalization();
  const loginLabel = t('h24_register');
  const newCustomerLabel = t('h24_new_customer_?');
  const registerNowLabel = t('h24_register_now');

  return (
    <UpperBlockContainer>
      <ButtonLink
        href={prefix.t('h24_login_page_url')}
        onClick={() => trackMyAccountTooltipClick(loginLabel, Element.Button)}
      >
        {loginLabel}
      </ButtonLink>
      <NewCustomerContainer {...newCustomerContainerStyles}>
        <Link
          href={prefix.t('h24_register_url')}
          onClick={() => trackMyAccountTooltipClick(registerNowLabel)}
        >
          {newCustomerLabel} {registerNowLabel}
        </Link>
      </NewCustomerContainer>
    </UpperBlockContainer>
  );
};

const UpperBlock = ({ customer }: UpperBlockProps) =>
  customer?.isLoggedIn ? (
    <AuthorisedUpperBlock fullName={customer.fullName} />
  ) : (
    <UnauthorisedUpperBlock />
  );

export default UpperBlock;
